// src/store/index.js
import requestService from '@/services/request.service';
import { createStore } from 'vuex'

export default createStore({
    state: {
        userData: null,
        inn: null,
        show: false,
        text: '',
        color: 'info',
        timeout: 3000,
        config: null
    },
    mutations: {
        SET_CONFIG(state, payload) {
            state.config = payload
        },
        SET_CONFIG_ERROR(state) {
            state.config = null
        },
        SET_USER_DATA(state, payload) {
            state.userData = payload;
            state.inn = payload.app.inn
        },
        OPEN(state, { text, color = 'info', timeout = 3000 }) {
            state.show = false
            setTimeout(() => {
            state.text = text
            state.color = color
            state.timeout = timeout
            state.show = true
            }, 0)
        },
        CLOSE(state) {
            state.show = false
        }
    },
    actions: {
        open({ commit }, payload) {
            commit('OPEN', payload)
        },

        success({ commit }, text) {
            commit('OPEN', { text, color: 'success' })
        },

        error({ commit }, text) {
            commit('OPEN', { text, color: 'error', timeout: 4000 })
        },

        info({ commit }, text) {
            commit('OPEN', { text, color: 'info' })
        },
        async fetchConfig({ commit }) {
            const url = `${process.env.VUE_APP_BASE_URL}/config/config.json`
            try {
                const { data } = await requestService.get(url)
                commit('SET_CONFIG', data)
                return data
            } catch (e) {
                commit('SET_CONFIG_ERROR')
                throw e
            }
        }
    },
    getters: {
        getUserData: state => state.userData,
        getInn: state => state.inn,
        getConfig: state => state.config,

        userHasAnyRole: state => (roles = []) => {
            if (!Array.isArray(state.userData?.roles) || !Array.isArray(roles) || !roles.length) {
                return false
            }
            return roles.some(role => state.userData.roles.includes(role))
        },

        userIsOmsu: (state, getters) => getters.userHasAnyRole(['OmsuDirector', 'OmsuSpecialist']),
    },
    modules: {}
})
